import { useMemo } from "react";
import { EncryptStorage } from "encrypt-storage";
import * as Constants from "common/constants";

export default function useCompanyAccess() {
	const es = new EncryptStorage("secret-key-value", { prefix: "@mwan" });
	const userInfo = es.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
	const selectedCompany = es.getItem(Constants.SelectedCompany);

	const menuPaths = useMemo(() => {
		try {
			if (!userInfo || !selectedCompany || !userInfo.userCompanyDictionary) return [];
			const companies = userInfo.userCompanyDictionary[selectedCompany] || [];

			const paths = [];
			for (const item of companies) {
				for (const perm of item.permissionResponseList || []) {
					for (const menu of perm.menuResponseList || []) {
						if (menu?.to) paths.push(menu.to);
					}
				}
			}
			return Array.from(new Set(paths));
		} catch {
			return [];
		}
	}, [userInfo, selectedCompany]);

	const hasAccess = (to) => menuPaths.includes(to);

	return { selectedCompany, menuPaths, hasAccess };
}
